import React from "react";
import {Link, Link as RouterLink} from "react-router-dom";
import {
    IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Delete, Edit} from "@material-ui/icons";
import styled from "styled-components";
import {
    usePagination,
    useRowSelect,
    useTable
} from "react-table";
import apiHelper from "../../../../util/ApiHelper";
import {CustomCheckbox, modal} from "../../../../util";
import {useLoading} from "../../../../util/LoadingProvider";
import {toast} from "react-toastify";
import DistrictListing
    from "../components/DistrictListing";
import VenueListing
    from "../components/VenueListing";
import {
    PaginationHandler
} from "../../../../util/useManualPagination";
import dayjs from "dayjs";
import PaginationBarForHandler from "../../../common/PaginationBarForHandler";

const useStyles = makeStyles((theme) => ({
    tabpanel: {
        background: "#FFFFFF",
    },
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    colLink: {
        textDecoration: "none",
        color: "#306F9D"
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
        background: "#ffffff",
        paddingTop: "10px",
        paddingBottom: "10px",
        minHeight: "800px",
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    button: {
        backgroundColor: "#306F9D",
        textTransform: "capitalize",
        color: "white",
        "&:hover": {
            backgroundColor: "#306F9D",
        },
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));

const statuses = {
    1: "active",
    2: "inactive",
};

const IndeterminateCheckbox = React.forwardRef(
    ({indeterminate, ...rest}, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return <CustomCheckbox type="checkbox"
                               ref={resolvedRef} {...rest} />;
    }
);

const StatusFilter = styled.ul`
  list-style: none;
  display: inline-flex;
  padding: 0;
  margin-left: 25px;

  li {
    button {
      border: 0px;
      background: transparent;
      color: #306f9d;
      font-size: 13px;
      line-height: 15px;
      padding: 0 10px;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #333333;
      }
    }

    &:not(:last-of-type) {
      button {
        border-right: 1px solid black;
      }
    }

    &:first-of-type {
      button {
        padding-left: 0;
      }
    }
  }
`;

function TabPanel(props) {
    const classes = useStyles();
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            <Box p={3} className={classes.box}>
                {children}
            </Box>
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`,
    };
}

const formatDatetime = (dt) => {
    return dayjs(dt).format("DD MMM YYYY, hh:mma");
};

function RegionManagementPage(props) {
    const {match} = props;
    const classes = useStyles();
    const [disabled, setDisabled] = React.useState(props.disabled);
    const [activeTab, setActiveTab] = React.useState(0);
    const [actionType, setActionType] = React.useState("");
    const [keyword, setKeyword] = React.useState("");
    const [queryString, setQueryString] = React.useState("");
    const [data, setData] = React.useState([]);
    const [totalPages, setTotalPages] = React.useState(1);
    const [status, setStatus] = React.useState(null);
    const [paginationHandler] = React.useState(new PaginationHandler());
    const {setLoading} = useLoading();
    const { type } = match.params;
    const [path, setPath] = React.useState(match.url);

    // for pagination
    const [elementCounts, setElementCounts] = React.useState({
        all: 0,
        active: 0,
        inactive: 0,
    });

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };


    const columns = React.useMemo(
        () => [
            {
                Header: "Region Name (English)",
                accessor: "localizations.en.name",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={`/hkiff/region-management/region/${row.original.id}`}
                            className={classes.colLink}
                        >
                            {String(row.original.localizations.en.name)}
                        </Link>
                    );
                },
            },
            {
                Header: "Region Name (Traditional Chinese)",
                accessor: "nametc",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={`/hkiff/region-management/region/${row.original.id}`}
                            className={classes.colLink}
                        >
                            {String(row.original.localizations.tc.name)}
                        </Link>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status.status",
                Cell: ({ row }) => {
                    return (
                        <Link
                            to={`/hkiff/region-management/region/${row.original.id}`}
                            className={classes.colLink}
                        >
                            {row.original.status.status === true ? "Active" : "Inactive"}
                        </Link>
                    );
                },
            },
            {
                Header: "Last Update",
                accessor: "updateTime",
                Cell: ({row}) => {
                    return formatDatetime(row.original.updateTime);
                },
            },
        ],
        [disabled]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        selectedFlatRows,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            initialState: {pageIndex: 0, pageSize: 10},
            manualPagination: true,
            pageCount: totalPages,
        },
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div
                            style={{display: "inline-flex"}}>
                            <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={`/hkiff/region-management/region/${row.original.id}`}
                            >
                                <Edit fontSize="small"/>
                            </IconButton>
                            {disabled || (
                                <IconButton
                                    className={classes.iconBtn}
                                    size="small"
                                    onClick={() => {
                                        deleteRegion(row.original.id);
                                    }}
                                >
                                    <Delete
                                        fontSize="inherit"/>
                                </IconButton>
                            )}
                        </div>
                    ),
                },
            ]);
        }
    );

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 1) {
            window.history.replaceState(
                null,
                "Region",
                "/hkiff/region-management/region"
            );
            setPath("/hkiff/region-management/region");
        } else if (newValue === 2) {
            window.history.replaceState(
                null,
                "District",
                "/hkiff/region-management/district"
            );
            setPath("/hkiff/region-management/district");
        } else {
            window.history.replaceState(
                null,
                "Venue",
                "/hkiff/region-management/venue"
            );
            setPath("/hkiff/region-management/venue");
        }
    };

    const getRegion = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.listRegion(
                "en",
                0,
                0,
                999999
            );
            paginationHandler.setPageIndex(0).setRows(result.data.content);
            const content = paginationHandler.filterRowsByAll().getRows();
            const totalPages = paginationHandler.getTotalPages();
            const all = paginationHandler.getTotalRows();
            const active = paginationHandler.getStatuslessRows()
                .filter((x) => x && x.status.status === true).length;
            const inactive = paginationHandler.getStatuslessRows()
                .filter((x) => x && x.status.status == false).length;
            setElementCounts({
                all,
                active,
                inactive,
            });
            setData(content.filter((x) => x));
            setTotalPages(totalPages);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [paginationHandler, setLoading]);

    React.useEffect(() => {
        if (type == "region") {
            setActiveTab(1);
        }
        if (type == "district") {
            setActiveTab(2);
        }
    }, [type]);

    React.useEffect(() => {
        if (paginationHandler) getRegion(); // only get when paginationHandler ready
    }, [getRegion, paginationHandler]);

    const statusFilterHandler = (targetStatus) => () => {
        setLoading(true);
        setStatus(targetStatus);
        let target;
        if (targetStatus === statuses[1]) {
            target = true;
        } else if (targetStatus === statuses[2]) {
            target = false;
        } else {
            target = null;
        }
        paginationHandler
            .resetRows()
            .setQueryStatus("status.status", target)
            .filterRowsByAll();
        console.log(paginationHandler.getRows());
        setData(paginationHandler.getRows());
        gotoPage(0);
        setLoading(false);
    };

    const triggerSearch = React.useCallback(() => {
        setLoading(true);
        setQueryString(keyword);
        paginationHandler
            .resetRows()
            .setQueryString(["localizations.en.name","localizations.tc.name"], keyword)
            .filterRowsByAll();
        setData(paginationHandler.getRows());
        console.log(paginationHandler.getRows());
        const all = paginationHandler.getStatuslessRows().length;
        const active = paginationHandler
            .getStatuslessRows()
            .filter((x) => x.status.status == true).length;
        const inactive = paginationHandler
            .getStatuslessRows()
            .filter((x) => x.status.status == false).length;
        setElementCounts({
            all,
            active,
            inactive,
        });
        gotoPage(0);
        setLoading(false);
    }, [gotoPage, keyword, paginationHandler, setLoading]);

    const deleteRegion = React.useCallback(async (id) => {
        const decision = await modal.fire({
            title: "Delete Region",
            text: "Are you sure to delete this region?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.hkiff.deleteRegionById(id);
                if (result.data.code === 0) {
                    toast.dark("Region deleted.");
                }
                await getRegion();
            } catch (err) {
                console.log(err);
            }
        }
    }, [rows, actionType, getRegion]);

    const handleBulkAction = React.useCallback(async () => {
        switch (actionType) {
            case "DELETE":
                const ids = selectedFlatRows.map((o) => o.original.id);
                if (ids.length > 0) {
                    const decision = await modal.fire({
                        title: "Delete Region",
                        text: `Are you sure to delete ${ids.length} region(s)?`,
                        showCancelButton: true,
                        confirmButtonText: `Delete`,
                    });
                    if (decision.isConfirmed) {
                        try {
                            const result = await apiHelper.hkiff.bulkDeleteRegion(ids);
                            if (result.data.code === 0) {
                                toast.dark(`${ids.length} region deleted.`);
                            }
                            await getRegion();
                        } catch (err) {
                            console.log(err);
                        }
                    }
                }
                break;
            default:
                break;
        }
    }, [rows, actionType, getRegion]);

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                Region Management
            </Typography>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                aria-label="nav tabs example"
                TabIndicatorProps={{
                    style: {
                        top: "0",
                        background: "#306F9D"
                    }
                }}
            >
                <Tab label="Venue" {...a11yProps(0)} />
                <Tab
                    label="Region" {...a11yProps(1)} />
                <Tab
                    label="District" {...a11yProps(2)} />
            </Tabs>
            <form>
                <TabPanel value={activeTab} index={0}>
                    <VenueListing path={path}/>
                </TabPanel>
                <TabPanel value={activeTab} index={1}>
                <StatusFilter>
                        <li>
                            <button
                                className={status === null ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(null)}
                            >
                                <Typography variant="p">All
                                    ({elementCounts.all})</Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === "active" ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[1])}
                            >
                                <Typography variant="p">
                                    Active
                                    ({elementCounts.active})
                                </Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === "inactive" ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[2])}
                            >
                                <Typography variant="p">
                                    Inactive
                                    ({elementCounts.inactive})
                                </Typography>
                            </button>
                        </li>
                        {String(selectedFlatRows)}
                    </StatusFilter>
                    <Grid
                        container
                        justify="space-between"
                        style={{padding: "0 25px 10px"}}
                    >
                        <Grid container item xs={3} md={3}>
                            <Box width="100%"
                                 component="span"
                                 display="flex">
                                <Box width="100%">
                                    <FormControl fullWidth
                                                 margin="dense"
                                                 variant="outlined">
                                        <InputLabel
                                            id="demo-simple-select-outlined-label">
                                            Bulk Actions
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={actionType}
                                            onChange={handleSelectChange}
                                            label="Bulk Actions"
                                        >
                                            <MenuItem
                                                value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem
                                                value={"DELETE"}>Delete</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleBulkAction}
                                        disabled={disabled}
                                    >
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid container item xs={12} md={8}>
                            <Box
                                width="100%"
                                component="span"
                                display="flex"
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Box display="flex">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        component={RouterLink}
                                        disabled={disabled}
                                        to={`${path}/new`}
                                    >
                                        Add New Region
                                    </Button>
                                </Box>
                                <Box display="flex">
                                    <TextField
                                        id="outlined-error"
                                        label="Search"
                                        variant="outlined"
                                        margin="dense"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        type="button"
                                        margin="dense"
                                        onClick={triggerSearch}
                                    >
                                        Search
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <TableContainer
                            component={Paper}
                            style={{
                                margin: "0 25px",
                                boxShadow: "none",
                                border: "1px solid #cccccc",
                            }}
                        >
                            <fieldset disabled={disabled}
                                      className="fieldset">
                                <Table
                                    aria-label="simple table"
                                    component="ul"
                                    style={{margin: "0"}}
                                    {...getTableProps()}
                                >
                                    <TableHead
                                        component="div">
                                        {headerGroups.map((headerGroup) => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <TableCell
                                                        {...column.getHeaderProps()}
                                                        className={`${column.className ?? ""}`}
                                                        style={{
                                                            paddingTop: 6,
                                                            paddingBottom: 6,
                                                            lineHeight: "1.1em",
                                                            height: "48px",
                                                        }}
                                                    >
                                                        {column.render("Header")}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row, index) => {
                                            prepareRow(row);
                                            return (
                                                <TableRow {...row.getRowProps()}>
                                                    {row.cells.map((cell) => {
                                                        return (
                                                            <TableCell
                                                                {...cell.getCellProps()}
                                                                className={`${cell.column.className ?? ""}`}
                                                                style={{
                                                                    paddingTop: 6,
                                                                    paddingBottom: 6,
                                                                    lineHeight: "1.1em",
                                                                    height: "48px",
                                                                }}
                                                            >
                                                                {cell.render("Cell")}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </fieldset>
                        </TableContainer>
                    </Grid>
                    <Grid
                        container
                        justify="flex-end"
                        style={{
                            paddingRight: "25px",
                            marginTop: "15px"
                        }}
                    >
                        <div className={classes.flexRow}>
                            <div></div>
                            <PaginationBarForHandler
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                setData={setData}
                                setTotalPages={setTotalPages}
                                paginationHandler={paginationHandler}
                                gotoPage={gotoPage}
                                pageIndex={pageIndex}
                                canPreviousPage={canPreviousPage}
                                previousPage={previousPage}
                                nextPage={nextPage}
                                canNextPage={canNextPage}
                                elementCounts={elementCounts}
                                status={status}
                            />
                        </div>
                    </Grid>
                </TabPanel>
                <TabPanel value={activeTab} index={2}>
                    <DistrictListing path={path}/>
                </TabPanel>
            </form>
        </div>
    );
}

export default RegionManagementPage;
